import {
  DbWorkflowState,
  useDeleteApiWorkflowsStatesByStateMutation,
  useGetApiWorkflowsStatesQuery,
  usePatchApiWorkflowsStatesByStateMutation,
  usePostApiWorkflowsStatesMutation,
} from '../../../../app/athenaApiGen';
import AdminCatalogPanel from '../AdminCatalogPanel';

// WorkflowState — note the path param is `state`, not `workflowState`. The
// response field is `workflowState`. Form name matches the response field.
const AdminWorkflowStatesPanel = () => (
  <AdminCatalogPanel<DbWorkflowState>
    tableName="Workflow State"
    apiPath="/api/workflows/states"
    pkAccessor="workflowState"
    useList={() => useGetApiWorkflowsStatesQuery({ archived: true })}
    useCreate={usePostApiWorkflowsStatesMutation}
    useUpdate={usePatchApiWorkflowsStatesByStateMutation}
    useDelete={useDeleteApiWorkflowsStatesByStateMutation}
    buildCreateArg={(v) => ({
      handlersWorkflowCatalogRequest: {
        name: (v.workflowState as string) ?? '',
        description: v.description as string | undefined,
      },
    })}
    buildUpdateArg={(row, v) => ({
      state: row.workflowState as string,
      handlersWorkflowCatalogUpdateRequest: {
        description: v.description as string | undefined,
      },
    })}
    buildDeleteArg={(row) => ({ state: row.workflowState as string })}
    fields={[
      {
        name: 'workflowState',
        label: 'Workflow State',
        type: 'text',
        required: true,
        immutableOnEdit: true,
        helperText:
          'Renaming a state can affect the active state-machine transition table — coordinate with backend before changing.',
      },
      { name: 'description', label: 'Description', type: 'textarea' },
      { name: 'archived', label: 'Archived', type: 'boolean' },
    ]}
    fkConflictMessage="Active workflows still reference this state. Resolve them before deleting."
  />
);

export default AdminWorkflowStatesPanel;
